import { createContext, useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, writeBatch, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

const DrawParticipantsContext = createContext<{
  participants: any[];
  activeParticipants: number;
  totalInvestment: number;
  updateParticipantsStatus: (drawId: string) => Promise<void>;
} | undefined>(undefined);

export function DrawParticipantsProvider({ children }: { children: React.ReactNode }) {
  const [participants, setParticipants] = useState<any[]>([]);
  const [activeParticipants, setActiveParticipants] = useState(0);
  const [totalInvestment, setTotalInvestment] = useState(0);

  useEffect(() => {
    const q = query(collection(db, 'participants'), where('isActive', '==', true));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const participantsList: any[] = [];
      let total = 0;

      snapshot.forEach((doc) => {
        const data = doc.data();
        participantsList.push(data);
        total += data.investmentAmount;
      });

      setParticipants(participantsList);
      setActiveParticipants(participantsList.length);
      setTotalInvestment(total);
    });

    return () => unsubscribe();
  }, []);

  const updateParticipantsStatus = async (drawId: string) => {
    const batch = writeBatch(db);
    const participantsRef = collection(db, 'participants');
    const snapshot = await getDocs(query(participantsRef, where('drawId', '==', drawId)));
    
    snapshot.forEach(doc => {
      batch.update(doc.ref, { isActive: false });
    });
    
    await batch.commit();
  };

  return (
    <DrawParticipantsContext.Provider value={{
      participants,
      activeParticipants,
      totalInvestment,
      updateParticipantsStatus
    }}>
      {children}
    </DrawParticipantsContext.Provider>
  );
} 